import { FormGroup } from "react-bootstrap";
//@ts-ignore
import TimezonePicker from "react-bootstrap-timezone-picker";
import DatePicker from "react-datepicker";
import styled from "styled-components";
import { RESTRICTION_TYPE } from "../../../witadmin/Common/constants";
import { InputMultiCheckbox } from "../InputMultiCheckbox";

export const Container = styled.div`
  a {
    cursor: pointer;
  }
`;

export const DatePickerContainer = styled.div`
  fieldset {
    border-bottom: none;
  }

  .react-datepicker__input-container {
    width: 300px;
  }
`;

export const DeleteBookingDateLink = styled.a`
  margin-top: 3px;
  margin-left: 15px;
`;

export const DatePickerGroupStyled = styled.div<any>`
  ${props =>
    (props && props.restrictionType === RESTRICTION_TYPE.OPEN_BOOKING) ||
    RESTRICTION_TYPE.OPEN_TRAVEL
      ? `
fieldset {
    padding-bottom: 0;
    margin-bottom: 0;
  }
`
      : undefined};
  margin-top: 20px;
`;

export const WeekdayPickerContainer = styled.div`
  fieldset {
    padding-bottom: 0;
    margin-bottom: 10px;
  }
`;

export const Message = styled.div``;

export const MessageTitle = styled.div`
  font-weight: 700;
`;

export const HourTimezoneContainer = styled.div`
  margin-top: 20px;
  margin-bottom: 20px;
`;

export const StyledMultiCheckBoxGroup = styled(InputMultiCheckbox)`
  & .multicheckbox {
    margin-top: 0;
  }
`;

export const StyledDatePicker = styled(DatePicker)`
  & .multicheckbox {
    margin-top: 0;
  }
`;

export const StyledTimezonePicker = styled(TimezonePicker)`
  // faux dropdown arrows
  & input {
    cursor: pointer;
  }

  &:after {
    content: "";
    border: solid ${({ theme }) => theme.regularTextColor};
    border-width: 0 2px 2px 0;
    display: inline-block;
    padding: 3px;
    transform: rotate(45deg);
    height: 8px;
    width: 8px;
    margin-left: -20px;
    z-index: 2;
    margin-top: 10px;
  }
`;

export const HourTimezone = styled(FormGroup)`
  display: flex;
  margin-top: 10px;
  margin-bottom: 10px !important;

  & > * {
    max-width: 150px;
    display: flex;
  }

  & > :not(.react-datepicker__tab-loop) {
    max-width: 100px;
    cursor: pointer;
    display: flex;
    & input {
      cursor: pointer;
    }
  }

  & > *:first-child {
    margin-right: 30px;
  }

  & > *:last-child {
    margin-left: 60px;
    max-width: 450px;
  }
`;
